import React, { PropsWithChildren } from 'react';

/**
 * Block属性面板
 * @description 根据当前选中Block渲染属性，并提供操作
 */
export function PicexProperties(props: PropsWithChildren<{}>) {
	return <div className=""></div>;
}
